module.exports = {"id":"167495","name":"Manuel Neuer","rating":"92","photo":"./data/images/photos/4/167495.png","club":{"name":"FC Bayern","logo":"./data/images/clubs/FCBayern.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManuelNeuer0.json
// module id = 2686
// module chunks = 0